export const getVideoThumb = (videoId: string, quality?: string) => {
	switch (quality) {
		case "high":
			return `https://img.youtube.com/vi/${videoId}/default.jpg`;
		case "med":
			return `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
		case "std":
			return `https://img.youtube.com/vi/${videoId}/sddefault.jpg`;
		case "max":
			return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
		default:
			return `https://img.youtube.com/vi/${videoId}/default.jpg`;
	}
};

export const cleanTitle = (title: string) => {
	return title.replace("amp;", "").trim();
};
